import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
export const globalfunc = {
  timeSince: (date) => {
    let secFormat = distanceInWordsStrict(new Date(), date, {unit: 's'})
    let seconds = parseInt(secFormat.replace(/ seconds/g, ""))
    var intervalType;

    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      intervalType = 'year';
    } else {
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) {
        intervalType = 'month';
      } else {
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
          intervalType = 'day';
        } else {
          interval = Math.floor(seconds / 3600);
          if (interval >= 1) {
            intervalType = "hour";
          } else {
            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
              intervalType = "min";
            } else {
              interval = seconds;
              intervalType = "second";
            }
          }
        }
      }
    }

    if (interval > 1 || interval === 0) {
      intervalType += 's';
    }

    return interval + ' ' + intervalType + ' ago';
  },
  getTeamOfParent: (parent, teams) => {
    for (const i in parent) {
      teams[parent[i]["team_id"]] = true;
      if (parent[i]["parent"]) {
        teams = globalfunc.getTeamOfParent(parent[i]["parent"], teams);
      }
    }
    return teams;
  },
  generateToken: (length) => {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    return result;
  },
  round: (value, decimals) => {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  },
  ordinal_suffix_of: (i) => {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
  },
  getAllParent: (teams, key) => {
    const organization = [];
    for(let x in teams[key]){
      
      if(teams[teams[key][x].team_id] !== undefined){
        organization.push({team_id: teams[key][x].team_id, parent: globalfunc.getAllParent(teams, teams[key][x].team_id)});
      }else{
        organization.push({team_id: teams[key][x].team_id});
      }
    }
    return organization;
  },
  generateRandomNumber() {
    const min = 1;
    const max = 999999999;
  
    let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    let formattedNumber = randomNumber.toFixed(0).padStart(9, '0');
  
    return formattedNumber;
  },
  truncateText: (text, maxLength) => {
    let length = maxLength;
    return text.length > length ? text.slice(0, length) + "..." : text;
  },
  addCommasInNumber: (value, decimal) => {
    let num = Number(value).toFixed(decimal);
    let str = num.toString().split(".");
    if (str[0].length >= 4) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }
    return `${str[0]}.${str[1]}`;
  },
  calculateStartDate: (year,month,startDay) => {
    let cycleStart = new Date(`${year}-${month}-${startDay}`);
    cycleStart.setMonth(cycleStart.getMonth() - 1);
    cycleStart.setDate(cycleStart.getDate() + 1);
    return cycleStart;
  }
  // calculateEndDate: (startDay) => {
  //   const today = new Date();
  //   let cycleStart = new Date(today.getFullYear(), today.getMonth(), startDay);
  //   if (today.getDate() < startDay) {
  //     cycleStart.setMonth(cycleStart.getMonth() - 1);
  //   }
  //   cycleStart.setMonth(cycleStart.getMonth() + 1);
  //   cycleStart.setDate(cycleStart.getDate() - 1);
  //   return cycleStart;
  // }
}